import React, { PureComponent } from "react";
import MessageBanner from './MessageBanner';

type Props = {
  children?: React.ReactNode;
  containerStyles?: any
}

export default class ErrorMessageBanner extends PureComponent<Props> {

  render() {
    return (
      <MessageBanner level="error" containerStyles={this.props.containerStyles}>
        {this.props.children}
      </MessageBanner>
    );
  }
  
}
